import React from 'react';
import './PoweredBy.css';
import logoImage from '../assets/images/white-png.png';

export default class PoweredBy extends React.Component {
	
	render = () => {
		return (
			<div className="powered-by-wrapper">
				<div className="powered-by-content">
					<span>Recruiting Website by </span>
					<img src={logoImage} alt="powered by Recsite Ltd."/>
				</div>
			</div>
		);
	};
}


// WEBPACK FOOTER //
// ./src/components/PoweredBy.js